// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1QSVM","title":"AfterFrontImage_title__2CK7K"};